import React, { useState, useEffect } from 'react'
import { SuccessModal } from '../../../Utils/SuccessModal/SuccessModal'
import { ErrorModal } from '../../../Utils/ErrorModal/ErrorModal'
import { ModalCargando } from '../../../Utils/Modal-Cargando/ModalCargando'
//import DEFAULT_URL from '../../../../api/url'
import { Alert, Modal, Row, Button, Col, Form, Container } from "react-bootstrap";
import './common.css'
const ModalNuevoFormulario = (props) => {
    const [modalError, setModalError] = useState(false);
    const [mensaje, setMensaje] = useState('');
    const [consideracion, setConsideracion] = useState('');
    const [modalCargando, setModalCargando] = useState(false);
    const [mensajeCargando, setMensajeCargando] = useState('');
    const [modalSucc, setModalSucc] = useState(false);
    const [prefijo, setPrefijo] = useState('');
    const [titulo, setTitulo] = useState('');
    const [preguntas, setPreguntas] = useState([]);
    const [contador, setContador] = useState(0);
    const [promocional, setPromocional] = useState('');
    const [encabezado, setEncabezado] = useState('');
    const [showAlert, setShowAlert] = useState(true);
    const [tipos, setTipos] = useState([]);
    const [ideas, setIdeas] = useState('block');
    const [seleccion, setSeleccion] = useState('block');
    const [tiposForm, setTiposForm] = useState([]);
    const [tipoFormulario, setTipoFormulario] = useState('');
    const [validacion, setValidacion] = useState('block');
    const [alert2, setAlert2] = useState(false);
    useEffect(async () => {
        async function fetchData() {
            fetch(process.env.REACT_APP_DEFAULT_URL + '/api/read/formulario/pregunta/tipos', { cache: "no-cache" })
                .then((res) => {
                    return res.json();
                })
                .then(data => {
                    setTipos(data.tipos);
                });
            fetch(process.env.REACT_APP_DEFAULT_URL + '/api/read/formulario/tipos/formulario', { cache: "no-cache" })
                .then((res) => {
                    return res.json();
                })
                .then(data => {
                    setTiposForm(data.rows);
                });
        }
        fetchData();
    }, [contador])

    const ocultar = () => {
        setModalError(false);
        setContador(contador + 1);
    }
    const ocultarModalCargando = () => {

    }
    const hideSuccess = () => {
        setModalSucc(false);
        setContador(contador + 1);
        props.onHide();
    }
    const onChange = (evt) => {
        switch (evt.target.name) {
            case "prefijo":
                setPrefijo(evt.target.value);
                break;
            case 'titulo':
                setTitulo(evt.target.value);
                break;
            case "promocional":
                setPromocional(evt.target.value);
                break;
            case "tipo":
                setTipoFormulario(evt.target.value);
                if (evt.target.value == '1' || evt.target.value == '4') {
                    setPromocional(props.evento.flier);
                    setPreguntas([...preguntas, { pregunta: 'Institución', tipo: '1' }, { pregunta: 'Puesto', tipo: '1' }, { pregunta: 'Teléfono', tipo: '1' }, { pregunta: 'País', tipo: '4' }, { pregunta: 'Seleccione el asesor que le atendió', tipo: '3' }]);
                    setValidacion('none');
                    setAlert2(true);
                } else {
                    setPreguntas([]);
                    setValidacion('block');
                    setAlert2(false);
                }
                break;
        }
        setContador(contador + 1);
    }
    const submit = (evt) => {
        evt.preventDefault();
        if (preguntas.length == 0) {
            setMensaje("No hay preguntas ingresadas");
            setConsideracion("Por favor, ingrese 1 o más preguntas");
            setModalError(true);
        } else {
            const prefix = prefijo + '-' + Date.now();
            const info = { titulo: titulo, correlativo: prefix, promocional: promocional, preguntas: preguntas, evento: props.evento.UniqueID, tipoFormulario: tipoFormulario };
            const requestOptions = {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(info)
            };
            setMensajeCargando("Almacenando formulario, por favor espere...")
            setModalCargando(true);
            fetch(process.env.REACT_APP_DEFAULT_URL + '/api/create/formulario', requestOptions)
                .then((res) => {
                    return res.json();
                })
                .then(data => {
                    if (data.codigo == 200) {
                        setModalCargando(false);
                        setMensaje('Formulario almacenado exitosamente');
                        setModalSucc(true);
                    } else {
                        setModalCargando(false);
                        setMensaje(data.respuesta);
                        setModalError(true);
                    }
                });
        }
    }
    const entering = () => {
        setEncabezado(props.evento.Nombre);
        setPrefijo('');
        setTitulo('');
        setPreguntas([]);
        setPromocional('');
        setIdeas('block');
        setSeleccion('block');
        setShowAlert(true);
        setTipoFormulario('');
        setValidacion('block');
        setAlert2(false);
        setContador(contador + 1);
    }
    const nuevaPregunta = () => {
        setPreguntas([...preguntas, { pregunta: '', tipo: '1' }]);
        setContador(contador + 1);
    }
    const porDefecto = () => {
        setPreguntas([...preguntas, { pregunta: 'Institución', tipo: '1' }, { pregunta: 'Puesto', tipo: '1' }, { pregunta: 'Teléfono', tipo: '1' }, { pregunta: 'País', tipo: '4' }, { pregunta: 'Seleccione el asesor que le atendió', tipo: '3' }]);
        setIdeas('none');
        setContador(contador + 1);
    }
    const onChangePregunta = (evt) => {
        let arr = evt.target.name.split('-');
        let valor_nuevo = evt.target.value;
        let arr_actual = preguntas;
        if (arr[0] == 'pregunta') {
            arr_actual[arr[1]].pregunta = valor_nuevo;
        } else {
            arr_actual[arr[1]].tipo = valor_nuevo;
        }
        setPreguntas(arr_actual);
        setContador(contador + 1);

    }
    const desplazarAbajo = (indice) => {
        let siguiente = preguntas[indice + 1];
        let actual = preguntas[indice];
        let arr_actual = preguntas;
        arr_actual[indice] = siguiente;
        arr_actual[indice + 1] = actual;
        setPreguntas(arr_actual);
        setContador(contador + 1);
    }
    const desplazarArriba = (indice) => {
        let siguiente = preguntas[indice - 1];
        let actual = preguntas[indice];
        let arr_actual = preguntas;
        arr_actual[indice] = siguiente;
        arr_actual[indice - 1] = actual;
        setPreguntas(arr_actual);
        setContador(contador + 1);
    }
    const eliminar = (indice) => {
        let arr_actual = preguntas;
        preguntas.splice(indice, 1);
        setPreguntas(arr_actual);
        setContador(contador + 1);
    }
    const insertSeleccionAsesor = () => {
        setPreguntas([...preguntas, { pregunta: 'Seleccione el asesor que le atendió', tipo: '3' }]);
        setSeleccion('none');
        setContador(contador + 1);
    }
    return (
        <Modal
            {...props}
            size="xl"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            scrollable
            onEnter={entering}
            style={{ color: 'black' }}
        >
            <Modal.Header closeButton style={{ backgroundColor: "#617785" }}>
                <Modal.Title id="contained-modal-title-vcenter" className="font-bold">
                    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="currentColor" className="bi bi-plus-circle-dotted" viewBox="0 0 16 16">
                        <path d="M8 0c-.176 0-.35.006-.523.017l.064.998a7.117 7.117 0 0 1 .918 0l.064-.998A8.113 8.113 0 0 0 8 0zM6.44.152c-.346.069-.684.16-1.012.27l.321.948c.287-.098.582-.177.884-.237L6.44.153zm4.132.271a7.946 7.946 0 0 0-1.011-.27l-.194.98c.302.06.597.14.884.237l.321-.947zm1.873.925a8 8 0 0 0-.906-.524l-.443.896c.275.136.54.29.793.459l.556-.831zM4.46.824c-.314.155-.616.33-.905.524l.556.83a7.07 7.07 0 0 1 .793-.458L4.46.824zM2.725 1.985c-.262.23-.51.478-.74.74l.752.66c.202-.23.418-.446.648-.648l-.66-.752zm11.29.74a8.058 8.058 0 0 0-.74-.74l-.66.752c.23.202.447.418.648.648l.752-.66zm1.161 1.735a7.98 7.98 0 0 0-.524-.905l-.83.556c.169.253.322.518.458.793l.896-.443zM1.348 3.555c-.194.289-.37.591-.524.906l.896.443c.136-.275.29-.54.459-.793l-.831-.556zM.423 5.428a7.945 7.945 0 0 0-.27 1.011l.98.194c.06-.302.14-.597.237-.884l-.947-.321zM15.848 6.44a7.943 7.943 0 0 0-.27-1.012l-.948.321c.098.287.177.582.237.884l.98-.194zM.017 7.477a8.113 8.113 0 0 0 0 1.046l.998-.064a7.117 7.117 0 0 1 0-.918l-.998-.064zM16 8a8.1 8.1 0 0 0-.017-.523l-.998.064a7.11 7.11 0 0 1 0 .918l.998.064A8.1 8.1 0 0 0 16 8zM.152 9.56c.069.346.16.684.27 1.012l.948-.321a6.944 6.944 0 0 1-.237-.884l-.98.194zm15.425 1.012c.112-.328.202-.666.27-1.011l-.98-.194c-.06.302-.14.597-.237.884l.947.321zM.824 11.54a8 8 0 0 0 .524.905l.83-.556a6.999 6.999 0 0 1-.458-.793l-.896.443zm13.828.905c.194-.289.37-.591.524-.906l-.896-.443c-.136.275-.29.54-.459.793l.831.556zm-12.667.83c.23.262.478.51.74.74l.66-.752a7.047 7.047 0 0 1-.648-.648l-.752.66zm11.29.74c.262-.23.51-.478.74-.74l-.752-.66c-.201.23-.418.447-.648.648l.66.752zm-1.735 1.161c.314-.155.616-.33.905-.524l-.556-.83a7.07 7.07 0 0 1-.793.458l.443.896zm-7.985-.524c.289.194.591.37.906.524l.443-.896a6.998 6.998 0 0 1-.793-.459l-.556.831zm1.873.925c.328.112.666.202 1.011.27l.194-.98a6.953 6.953 0 0 1-.884-.237l-.321.947zm4.132.271a7.944 7.944 0 0 0 1.012-.27l-.321-.948a6.954 6.954 0 0 1-.884.237l.194.98zm-2.083.135a8.1 8.1 0 0 0 1.046 0l-.064-.998a7.11 7.11 0 0 1-.918 0l-.064.998zM8.5 4.5a.5.5 0 0 0-1 0v3h-3a.5.5 0 0 0 0 1h3v3a.5.5 0 0 0 1 0v-3h3a.5.5 0 0 0 0-1h-3v-3z" />
                    </svg>
                    &nbsp;&nbsp;&nbsp;Registrar formulario
                </Modal.Title>
            </Modal.Header>
            <Modal.Body style={{ backgroundColor: "#617785", height: '80vh' }} className="cuerpo-modal-nuevo-cliente">
                <Container>
                    <Form onSubmit={submit} style={{ height: '100%' }}>
                        <Row style={{ height: '90%' }}>
                            <Col xs={12} md={6} lg={6} className="preguntas-crear-formulario" style={{ height: '90%' }}>
                                {showAlert &&
                                    <Row style={{ padding: '1%' }}>
                                        <Alert variant="danger" onClose={() => setShowAlert(false)} dismissible>
                                            <Alert.Heading>Aclaración</Alert.Heading>
                                            <p>
                                                No ingresar preguntas solicitando correo electrónico, nombres y apellidos, estos campos
                                                están por defecto en todos los formularios.
                                            </p>
                                            <hr />
                                            <p className="mb-0">
                                                Si usted ingresa este tipo de preguntas, en el formulario resultante, se tendrán estas preguntas repetidas.
                                            </p>
                                        </Alert>
                                    </Row>
                                }
                                <Row>
                                    <h1 style={{ textAlign: 'center' }}>Encabezado de formulario</h1>
                                </Row>
                                <Row>
                                    <Container>
                                        <Row>
                                            <Col xs={12} md={12} lg={12}>
                                                <Form.Group className="mb-3" controlId="prefijo">
                                                    <Form.Label>Prefijo de acceso</Form.Label>
                                                    <Form.Control required type="text" placeholder="Ingrese el prefijo de acceso" name="prefijo" value={prefijo} onChange={onChange} />
                                                </Form.Group>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col xs={12} md={12} lg={12}>
                                                <Form.Group className="mb-3" controlId="titulo">
                                                    <Form.Label>Título</Form.Label>
                                                    <Form.Control type="text" required placeholder="Ingrese el título " name="titulo" value={titulo} onChange={onChange} />
                                                </Form.Group>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col xs={12} md={12} lg={12}>
                                                <Form.Group className="mb-3" controlId="titulo">
                                                    <Form.Label>Promocional</Form.Label>
                                                    <Form.Control readOnly={validacion == 'none'} type="text" required placeholder="Ingrese enlace a flier promocional " name="promocional" value={promocional} onChange={onChange} />
                                                </Form.Group>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col xs={12} md={12} lg={12}>
                                                <Form.Group className="mb-3" controlId="tipo">
                                                    <Form.Label>Tipo de formulario</Form.Label>
                                                    <Form.Control as="select" required aria-label="tipo" name="tipo" onChange={onChange} value={tipoFormulario}>
                                                        <option value="" key="0">Seleccione el tipo de formulario</option>
                                                        {tiposForm.map(tipo => <option key={tipo.UniqueID} value={tipo.UniqueID}>{tipo.Nombre}</option>)}
                                                    </Form.Control>
                                                </Form.Group>
                                            </Col>
                                        </Row>
                                    </Container>
                                </Row>
                            </Col>
                            {alert2 &&
                                <Col xs={12} md={6} lg={6}>
                                    <Alert variant="success">
                                        <Alert.Heading>¡Listo!</Alert.Heading>
                                        <p>
                                            Las preguntas de su formulario para inscripción de cortesía
                                            se han generado exitosamente.
                                        </p>
                                        <hr />
                                        <p className="mb-0">
                                            Solo complete la información de encabezado y este formulario estará
                                            listo para su uso.
                                        </p>
                                    </Alert>
                                </Col>
                            }
                            <Col xs={12} md={6} lg={6} style={{ height: '100%', display: validacion }}>
                                <Row style={{ height: '20%' }}>
                                    <h1 style={{ textAlign: 'center' }}>Preguntas</h1>
                                </Row>
                                <Row style={{ height: '70%' }}>
                                    <Container>
                                        <Row style={{ height: '20%' }}>
                                            <Col xs={1} md={1} lg={1}>
                                                <div style={{ color: 'white', cursor: 'pointer' }} data-toggle="tooltip" data-placement="top" title="Nueva pregunta" onClick={() => nuevaPregunta()}>
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="currentColor" className="bi bi-plus-lg" viewBox="0 0 16 16">
                                                        <path fillRule="evenodd" d="M8 2a.5.5 0 0 1 .5.5v5h5a.5.5 0 0 1 0 1h-5v5a.5.5 0 0 1-1 0v-5h-5a.5.5 0 0 1 0-1h5v-5A.5.5 0 0 1 8 2Z" />
                                                    </svg>
                                                </div>
                                            </Col>
                                            <Col xs={1} md={1} lg={1} style={{ display: ideas }}>
                                                <div style={{ color: 'white', cursor: 'pointer' }} data-toggle="tooltip" data-placement="top" title="Preguntas genéricas" onClick={() => porDefecto()}>
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="currentColor" className="bi bi-lightbulb" viewBox="0 0 16 16">
                                                        <path d="M2 6a6 6 0 1 1 10.174 4.31c-.203.196-.359.4-.453.619l-.762 1.769A.5.5 0 0 1 10.5 13a.5.5 0 0 1 0 1 .5.5 0 0 1 0 1l-.224.447a1 1 0 0 1-.894.553H6.618a1 1 0 0 1-.894-.553L5.5 15a.5.5 0 0 1 0-1 .5.5 0 0 1 0-1 .5.5 0 0 1-.46-.302l-.761-1.77a1.964 1.964 0 0 0-.453-.618A5.984 5.984 0 0 1 2 6zm6-5a5 5 0 0 0-3.479 8.592c.263.254.514.564.676.941L5.83 12h4.342l.632-1.467c.162-.377.413-.687.676-.941A5 5 0 0 0 8 1z" />
                                                    </svg>
                                                </div>
                                            </Col>
                                            <Col xs={1} md={1} lg={1}>
                                                <div style={{ color: 'white', cursor: 'pointer', display: seleccion }} data-toggle="tooltip" data-placement="top" title="Agregar pregunta de selección de asesor" onClick={() => insertSeleccionAsesor()}>
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="currentColor" className="bi bi-person-circle" viewBox="0 0 16 16">
                                                        <path d="M11 6a3 3 0 1 1-6 0 3 3 0 0 1 6 0z" />
                                                        <path fillRule="evenodd" d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8zm8-7a7 7 0 0 0-5.468 11.37C3.242 11.226 4.805 10 8 10s4.757 1.225 5.468 2.37A7 7 0 0 0 8 1z" />
                                                    </svg>
                                                </div>
                                            </Col>
                                        </Row>
                                        <Row style={{ height: '80%' }} className="preguntas-crear-formulario">
                                            <Container>
                                                {preguntas.map((pregunta, indice) =>
                                                    <Row key={indice}>
                                                        <Container>
                                                            <Row>
                                                                {indice != 0 &&
                                                                    <Col xs={9} md={9} lg={9}>
                                                                    </Col>
                                                                }{(indice == 0 || indice == (preguntas.length - 1)) &&
                                                                    <Col xs={10} md={10} lg={10}>
                                                                    </Col>
                                                                }
                                                                {indice != 0 &&
                                                                    <Col xs={1} md={1} lg={1}>
                                                                        <div style={{ color: 'white', cursor: 'pointer' }} data-toggle="tooltip" data-placement="top" title="Desplazar hacia arriba" onClick={() => desplazarArriba(indice)}>
                                                                            <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="currentColor" className="bi bi-caret-up" viewBox="0 0 16 16">
                                                                                <path d="M3.204 11h9.592L8 5.519 3.204 11zm-.753-.659 4.796-5.48a1 1 0 0 1 1.506 0l4.796 5.48c.566.647.106 1.659-.753 1.659H3.204a1 1 0 0 1-.753-1.659z" />
                                                                            </svg>
                                                                        </div>
                                                                    </Col>
                                                                }
                                                                {indice < (preguntas.length - 1) &&
                                                                    <Col xs={1} md={1} lg={1}>
                                                                        <div style={{ color: 'white', cursor: 'pointer' }} data-toggle="tooltip" data-placement="top" title="Desplazar hacia abajo" onClick={() => desplazarAbajo(indice)}>
                                                                            <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="currentColor" className="bi bi-caret-down" viewBox="0 0 16 16">
                                                                                <path d="M3.204 5h9.592L8 10.481 3.204 5zm-.753.659 4.796 5.48a1 1 0 0 0 1.506 0l4.796-5.48c.566-.647.106-1.659-.753-1.659H3.204a1 1 0 0 0-.753 1.659z" />
                                                                            </svg>
                                                                        </div>
                                                                    </Col>
                                                                }
                                                                <Col xs={1} md={1} lg={1}>
                                                                    <div style={{ color: 'white', cursor: 'pointer' }} data-toggle="tooltip" data-placement="top" title="Borrar pregunta" onClick={() => eliminar(indice)}>
                                                                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" className="bi bi-trash-fill" viewBox="0 0 16 16">
                                                                            <path d="M2.5 1a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1H3v9a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V4h.5a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H10a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1H2.5zm3 4a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 .5-.5zM8 5a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7A.5.5 0 0 1 8 5zm3 .5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 1 0z" />
                                                                        </svg>
                                                                    </div>
                                                                </Col>
                                                            </Row>
                                                            <Row>
                                                                <Col xs={12} md={12} lg={12}>
                                                                    <Form.Group className="mb-3" controlId="titulo">
                                                                        <Form.Label>Pregunta #{indice + 1}</Form.Label>
                                                                        <Form.Control type="text" required placeholder="Ingrese la pregunta " name={"pregunta-" + indice} value={pregunta.pregunta} onChange={onChangePregunta} />
                                                                    </Form.Group>
                                                                </Col>
                                                            </Row>
                                                            <Row>
                                                                <Col xs={12} md={12} lg={12}>
                                                                    <Form.Group className="mb-3" controlId="tipo">
                                                                        <Form.Label>Indique el tipo de pregunta</Form.Label>
                                                                        <Form.Control required as="select" aria-label="tipo" name={"tipo-" + indice} value={pregunta.tipo} onChange={onChangePregunta}>
                                                                            <option value="" key="0">Seleccione el tipo de pregunta</option>
                                                                            {tipos.map(tipo => <option key={tipo.UniqueID} value={tipo.UniqueID}>{tipo.nombre}</option>)}
                                                                        </Form.Control>
                                                                    </Form.Group>
                                                                </Col>
                                                            </Row>
                                                        </Container>
                                                    </Row>
                                                )}
                                            </Container>
                                        </Row>
                                    </Container>
                                </Row>
                            </Col>
                        </Row>
                        <Row style={{ height: '10%' }}>
                            <Button variant="light" className="font-bold" type="submit">Guardar</Button>
                        </Row>
                    </Form>
                </Container>
            </Modal.Body >
            <ErrorModal
                color={"#b5bad0"}
                show={modalError}
                onHide={ocultar}
                mensaje={mensaje}
                consideracion={consideracion}
            />
            <ModalCargando
                color={"#b5bad0"}
                show={modalCargando}
                onHide={ocultarModalCargando}
                mensaje={mensajeCargando}
            />
            <SuccessModal
                color={"#b5bad0"}
                show={modalSucc}
                onHide={hideSuccess}
                mensaje={mensaje}
                consideracion={consideracion}
                enlace={''}
                llevaenlace={false}
            />
        </Modal >
    )
}

export default ModalNuevoFormulario